module.exports = __webpack_public_path__ + "static/media/natural-stone.4f5e4e03.svg";